export const FUNDING_REQUEST_CONTRACT_TYPES = {
  NON_FACTORED_STANDARD: "NON_FACTORED_STANDARD",
  NON_FACTORED_BILL_OUT: "NON_FACTORED_BILL_OUT",
  NON_FACTORED_PAYMENT_FORWARD: "NON_FACTORED_PAYMENT_FORWARD",
  SELF_FINANCE_NO_INVOICE: "SELF_FINANCE_NO_INVOICE",
  SELF_FINANCE_WITH_INVOICE: "SELF_FINANCE_WITH_INVOICE",
  SELF_FINANCE_WITH_INVOICE_OFF_PLATFORM: "SELF_FINANCE_WITH_INVOICE_OFF_PLATFORM",
  SELF_FINANCE_RECEIVABLES: "SELF_FINANCE_RECEIVABLES",
  SELF_FINANCE_LEDGER_DEPOSIT: "SELF_FINANCE_LEDGER_DEPOSIT",
  STD_BROKER: "STD_BROKER"
};

export const FUNDING_REQUEST_CONTRACT_TYPES_MAP = {
  NON_FACTORED_STANDARD: "Non-Factored Pay Carrier",
  NON_FACTORED_BILL_OUT: "Non-Factored Bill Out Only",
  NON_FACTORED_PAYMENT_FORWARD: "Non-Factored Payment Forward",
  SELF_FINANCE_NO_INVOICE: "Self Finance No Invoice",
  SELF_FINANCE_WITH_INVOICE: "Self Finance With Invoice",
  SELF_FINANCE_WITH_INVOICE_OFF_PLATFORM: "Self Finance w/ Invoice (Off-Platform)",
  SELF_FINANCE_RECEIVABLES: "Self Finance Receivables",
  SELF_FINANCE_LEDGER_DEPOSIT: "Self Finance Ledger Deposit",
  STD_BROKER: "Factored"
};

export type FundingRequestContractType = keyof typeof FUNDING_REQUEST_CONTRACT_TYPES_MAP;
